var Observable_1 = require('../../Observable');
var catch_1 = require('../../operator/catch');
Observable_1.Observable.prototype.catch = catch_1._catch;
//# sourceMappingURL=catch.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/catch.js
 ** module id = 329
 ** module chunks = 1
 **/